// Context
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useJob } from "../../../hooks/useJobs";
import Modal from "../../common/Modal";

function ModalUserActions({ close, show }) {
  const { t } = useTranslation();
  const { userActions } = useJob();
  const navigate = useNavigate();

  const openChat = (action) => {
    close();
    navigate(`/chat/${action.chatId}`);
  };

  return (
    <Modal show={show} close={close} size="medium" title={t("modals.userActions.title")} className={"ticket-modal"}>
      {userActions.length > 0 ? (
        <>
          {userActions.map((action, index) => (
            <div key={index} className="user-action">
              <button className="link mr-10" onClick={() => openChat(action)}>
                {action.chatId}
              </button>
              <span>{action.context?.label}</span>
            </div>
          ))}
        </>
      ) : (
        <p>{t("modals.userActions.noRequests")}</p>
      )}
    </Modal>
  );
}

export default ModalUserActions;
